import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { MarkupField } from '../Components/MarkupField';
import { Name } from './Elements/Name';
import { Timestamp } from './Elements/Timestamp';
import { Tooltip } from './Elements/Tooltip';
import { User } from './Elements/User';
import { ContentTooltipProps, TooltipDescriptionTestId } from './TooltipHelper';

export function CollectionTooltip(props: ContentTooltipProps): JSX.Element {

  return (
    <Tooltip>
      <Name name={props.content.name} />
      <MarkupField markup={props.content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <User user={props.content.owner} label={Messages.owner()} urls={props.urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
